import _ from 'lodash';
// import objectAssign from 'object-assign';
import * as types from '../constants/actionTypes';
// import $ from 'jquery';
import 'whatwg-fetch';
import { push } from 'react-router-redux';
import toastr from 'toastr';
import * as utils from './actionUtils';
// import dateHelper from '../utils/dateHelper';

let serverUrl = 'http://localhost:8000';
if (process.env.NODE_ENV === 'production') {
  serverUrl = 'https://arrangement.amerikanskeidretter.no';
}

export function getCurrentUserDetails() {
  return function (dispatch) {
    dispatch(utils.loadDetails(
      'current_user',
      types.LOAD_CURRENT_USER_SUCCESS,
      types.LOAD_CURRENT_USER_FAILURE));
  };
}

export function loadUsers() {
  return function (dispatch) {
    dispatch({
      type: types.LOAD_USERS,
    });
    dispatch(utils.loadList(
      'users/',
      types.LOAD_USERS_SUCCESS,
      types.LOAD_USERS_FAILURE,
      undefined,
      (error) => {toastr.error(error.detail, "Kan ikke lastes:");}
    ));
  };
}

export function loadGroups() {
  return function (dispatch) {
    dispatch({
      type: types.LOAD_GROUPS,
    });
    dispatch(utils.loadList(
      'users/groups',
      types.LOAD_GROUPS_SUCCESS,
      types.LOAD_GROUPS_FAILURE,
      undefined,
      undefined
    ));
  };
}

export function updatePassword(id, detials) {
  return function (dispatch) {
    dispatch({
      type: types.UPDATE_USER_PASSWORD,
    });
    dispatch(utils.update(
      'users/' + id + '/change_password',
      detials,
      types.UPDATE_USER_PASSWORD_SUCCESS,
      types.LOAD_USER_DETAILS_FAILURE,
      () => {toastr.success("Passord lagret");},
      (error) => {
        // console.log(error.detail);
        toastr.warning(error.detail, "Lagring feilet");
      }
    ));
  };
}

export function updateUser(details) {
  // let reorderedDetails = objectAssign({}, detials);
  // let groups = _.map(detials.group_list, 'id');
  // let clubs  = _.map(detials.club_list, 'id');
  // let events = _.map(detials.event_list, 'id');
  // delete reorderedDetails.group_list;
  // delete reorderedDetails.club_list;
  // delete reorderedDetails.event_list;
  return function (dispatch) {
    dispatch({
      type: types.LOAD_USER_DETAILS,
    });
    dispatch(utils.update(
      'users/' + details.id,
      details,
      types.LOAD_USER_DETAILS_SUCCESS,
      types.LOAD_USER_DETAILS_FAILURE,
      () => {toastr.success("Lagret");},
      (error) => {toastr.warning(error.detail, "Lagring feilet");}
    ));
  };
}

export function createUser(detials) {
  return function (dispatch) {
    dispatch({
      type: types.LOAD_USER_DETAILS,
    });
    dispatch(utils.create(
      'users/',
      detials,
      types.LOAD_USER_DETAILS_SUCCESS,
      types.LOAD_USER_DETAILS_FAILURE,
      (result) => {
        toastr.success("Opprettet");
        dispatch(push('/bruker/' + result.id));
      },
      (error) => {toastr.warning(error.detail, "Feilmelding:");}
    ));
  };
}

export function deleteUser(id) {
  return function (dispatch, getState) {
    let list = getState().users.list;
    list = _.filter(list, (item) => {
      return item.id !== id;
    });
    dispatch({
      type: types.LOAD_USERS_SUCCESS,
      list: list,
      listUpdated: Date.now()});
    dispatch(utils.beginAjaxCall());
    utils.deleteData('users/' + id, () => {
      toastr.success('Slettet');
    }, 0);
  };
}

export function loadUserDetails(userId) {
  return function (dispatch) {
    dispatch({
      type: types.LOAD_USER_DETAILS,
    });
    dispatch(utils.loadDetails(
      'users/' + userId,
      types.LOAD_USER_DETAILS_SUCCESS,
      types.LOAD_USER_DETAILS_FAILURE,
      undefined,
      (error) => {toastr.error(error.detail, "Kan ikke lastes:");}
    ));
  };
}



export function logout() {
  return function (dispatch) {
    dispatch(push('/login'));
    delete localStorage.token;
    delete localStorage.currentUser;
    toastr.info('Du er nå logget ut');
    return dispatch({
      type: types.LOGOUT,
    });
  };
}


export function loginSuccess(result) {
  return function (dispatch) {
    if (result.token != undefined) {
      localStorage.token = result.token;
      toastr.success('Du er nå logget inn');
      dispatch(push('/'));
      dispatch(getCurrentUserDetails());
      dispatch({
        type: types.LOGIN_SUCCESS,
      });
    } else {
      toastr.error('Log inn feilet');
      dispatch(push('/login'));
      dispatch({
        type: types.LOGIN_FAILED,
        error: "Ukjent brukernavn eller passord"
      });
    }
  };
}

export function login(username, pass) {
  return function (dispatch) {
    fetch(serverUrl + '/api/v1/obtain-auth-token/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: username,
        password: pass,
      })
    }).then((response) => {
      return response.json();
    }).then((result) => {
      dispatch(loginSuccess(result));
    });
  };

}



/** WEBPACK FOOTER **
 ** ./src/actions/userActions.js
 **/